import { useEffect, useState } from "react";
import "./style.scss";
import UsersTab from "./components/UsersTab";
import { useParams } from "react-router-dom";
import getProductDetailInteractor from "@/@core/interactor/product/get-product-id";
import ProductForm from "../ProductsForm";

type ProductDetailActiveTab = "product-information" | "users";

const ProductDetail = () => {
  const {id} = useParams()

  const [activeTab, setActiveTab] = useState<ProductDetailActiveTab>("users");

  return (
    <div className="product-detail-page-wrapper">
      <h1>Products</h1>

      <div className="tab-wrapper">
        <div
          className={
            "tab-item" + (activeTab === "product-information" ? " active" : "")
          }
          onClick={() => setActiveTab("product-information")}
        >
          Product Information
        </div>
        <div
          className={"tab-item" + (activeTab === "users" ? " active" : "")}
          onClick={() => setActiveTab("users")}
        >
          Users
        </div>
      </div>

      {activeTab === "users" && <UsersTab />}
      {activeTab === "product-information" && <ProductForm/>}
    </div>
  );
};

export default ProductDetail;
